// @systeme: contrat
// Amélioration continue : ce que l'utilisatrice nous signale quand quelque chose ne va
// pas, ou quand elle a une idée. Voir docs/produit.md §12.
import { z } from 'zod';
import { SchemaCibleRetour, SchemaTypeRetour } from '../enumerations.js';
export const SchemaCreationRetour = z.object({
    type: SchemaTypeRetour,
    cible: SchemaCibleRetour.default('aucune'),
    cibleId: z.uuid().nullable().optional(),
    /** Le chemin de l'écran d'où part le retour, pour comprendre le contexte. */
    ecran: z.string().max(200).optional(),
    message: z.string().trim().min(1, { error: 'Dis-nous en un mot ce qui ne va pas.' }).max(2000),
});
export const SchemaRetour = z.object({
    id: z.uuid(),
    type: SchemaTypeRetour,
    cible: SchemaCibleRetour,
    cibleId: z.uuid().nullable(),
    ecran: z.string().nullable(),
    message: z.string(),
    creeLe: z.iso.datetime({ offset: true }),
});
//# sourceMappingURL=retours.js.map